import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
export default function SuccessSubmitDataAlert({ children }) {
	return (
		<Alert
			severity="success"
			sx={{
				"& .MuiAlert-icon": {
					fontSize: 40,
				},
			}}
		>
			<AlertTitle variant="h4">Informations</AlertTitle>
			{children}
		</Alert>
	);
}
